/**
 * Created by intellicar-rinas on 22/3/18.
 */
import _ from 'lodash';

const isPaverData =(vehicle)=> {
    return vehicle && vehicle.vehiclemeta && (vehicle.vehiclemeta.model.trim().toLowerCase()) === ('Asphalt Paver P5320'.trim().toLowerCase());
};

const isTVSData = vehicle => {
    return vehicle && vehicle.vehiclemeta && vehicle.vehiclemeta.model.trim().toLowerCase() === 'TVS_POC'.toLowerCase();
}

const processOdometer =(val, data, vehicle, source)=> {
    val = parseInt(val, 10);
    // let etrioid = "1979"
    // if(isNaN(val))
    //     return 0;

    // let group = vehicle.groups;
    // for(let idx in group){
    //     let gpath = (group[idx].path).split('/')
    //     // console.log("gpath frm keymap",gpath,vehicle.vehicleno)
    //     if(gpath.includes(etrioid)){
    //         return vehicle.stats.odometer = 'NA'
    //     }
    // }
    if(source === 'CAN') {
        vehicle.stats.canOdometerRaw = val;
    } else if(source === 'GPS') {
        vehicle.stats.gpsOdometerRaw = val;
    } else if(source === 'GPSSPEED') {
        vehicle.stats.gpsSpeedOdometerRaw = val;
    }
    if(data.od) vehicle.stats.gpsOdometerFinal = parseInt(data.od, 10);
    if(vehicle.vehiclemeta && vehicle.vehiclemeta.odofrom === "speed_odometer" && source === 'GPSSPEED') {
        let finalodo = (vehicle.stats.gpsSpeedOdometerRaw||0);

        vehicle.stats.gpsSpeedOdometerFinal = finalodo;
        vehicle.stats.odoSource = 'SPEED'
        return finalodo;
    } else if(vehicle.vehiclemeta && vehicle.vehiclemeta.odofrom === "can_odometer" && source === 'CAN') {
        if(vehicle && vehicle.stats && !isNaN(vehicle.stats.canOdometerRaw)) {
            vehicle.stats.canOdometerFinal = vehicle.stats.canOdometerRaw;
            return vehicle.stats.canOdometerRaw;
        }
    } else if(vehicle.vehiclemeta && vehicle.vehiclemeta.odofrom === "can_odc" && source === 'CAN') {
        if(data.odc) vehicle.stats.canOdometerFinal = parseInt(data.odc, 10);

        return vehicle.stats.canOdometerFinal;

    } else if(vehicle.vehiclemeta && (!vehicle.vehiclemeta.odofrom || vehicle.vehiclemeta.odofrom === "gps_odometer") && source === 'GPS') {
        let finalodo = vehicle.stats.gpsOdometerRaw ? vehicle.stats.gpsOdometerRaw  : 0;

        vehicle.stats.gpsOdometerFinal = finalodo;

        return finalodo;
    }

    vehicle.stats.odoSource = (!vehicle.vehiclemeta.odofrom || vehicle.vehiclemeta.odofrom === 'gps_odometer') ? 'GPS' : 'CAN';
    // let group = vehicle.groups;
    // for(let idx in group){
    //     if(group[idx].groupid == 1979)
    //     return vehicle.stats.odometer = 'NA'
    // }
    return isNaN(vehicle.stats.odometer) ? 'NA' : vehicle.stats.odometer;
};



const getFuelInLiters =(val, data, vehicle)=> {
    if(!val) {
        return vehicle.stats.fuelInLiters;
    } 
    val = Math.min(100, parseInt(val || 0,10));
    if(vehicle.fueltankcapacity) {
        return parseInt(val / 100 * vehicle.fueltankcapacity);
    }
    // return val;
};


const getFuel2InLiters =(val, data, vehicle)=> {
    if(!val) {
        return vehicle.stats.fuel2InLiters;
    } 
    val = Math.min(100, parseInt(val || 0, 10));
    if(vehicle.fueltankcapacity2) {
        return parseInt(val / 100 * vehicle.fueltankcapacity2);
    }
    return (val ? val : vehicle.stats.fuel2InLiters) || 0;
};


const isFuelInLitersAvailable =(val, data, vehicle)=> {
    return vehicle.fueltankcapacity;
};


const isFuel2InLitersAvailable =(val, data, vehicle)=> {
    return vehicle.fueltankcapacity2;
};


const getBatteryVoltage = (val) => {
    return val ? val : 0;
}


const noCommThreshold = 1000 * 60 * 60 * 48;
const processNoComm =(val, data, vehicle)=> {
    if(vehicle && vehicle.stats) {
        return Date.now() - vehicle.stats.utctime > noCommThreshold ? 1 : 0;
    }
    return 0;
};

const kleNoCommThreshold = 1000 * 60 * 60 * 48;
const processKLENoComm =(val, data, vehicle)=> {
    if(vehicle && vehicle.stats) {
        return Date.now() - vehicle.stats.kletime > kleNoCommThreshold ? 1 : 0;
    }
    return 0;
};


const updateTPMSTire =(val, data, vehicle, dataByID, sensor)=> {
    sensor.tyreid = parseInt(sensor.tyreid, 10);
    if(sensor.tyreid in dataByID) {
        sensor.temperature = parseInt(dataByID[sensor.tyreid].temp, 10);
        sensor.pressure = parseInt(dataByID[sensor.tyreid].pressure,10);
    }
};

const processTPMS =(val, data, vehicle)=> {
    if(vehicle.tpmsconfig) {
        let dataByID = {};
        for(let idx in val) {
            dataByID[val[idx].tyreid] = val[idx];
        }
        for(let idx in vehicle.tpmsconfig) {
            for(let jdx in vehicle.tpmsconfig[idx].left) {
                updateTPMSTire(val, data, vehicle, dataByID, vehicle.tpmsconfig[idx].left[jdx])
            }
            for(let jdx in vehicle.tpmsconfig[idx].right) {
                updateTPMSTire(val, data, vehicle, dataByID, vehicle.tpmsconfig[idx].right[jdx])
            }
        }
    }
};


const isValid =(val, data, vehicle, key, config)=> {
    if(vehicle && vehicle.stats && vehicle.stats.utctime && Date.now() - vehicle.stats.utctime <= 1000 * 60 * 2) {
        return val;
    }
    return ('default' in config) ? config.default : 0;
};

const isGPSSpeedValid =(val, data, vehicle, key, config)=> {
    if(vehicle && vehicle.stats && vehicle.deviceTypesList) {
        if(vehicle.deviceTypesList.indexOf('concox_assettracker') !== -1 ||
            vehicle.deviceTypesList.indexOf('concox_at4') !== -1) {
            return val;
        }
        if(vehicle.stats.utctime && Date.now() - vehicle.stats.utctime <= 1000 * 60 * 2) {
            return val;
        }
    }
    return ('default' in config) ? config.default : 0;
};

// 1 forward
// 2 reverse
// 4 neutral
// 8 boost



const processGear = (val, data, vehicle)=> {
    if(val) return val
};

/*
    turns NA to 0
*/
const NACheck = (val, data, vehicle, key)=> {
    if(val === 'NA') {
        return vehicle.stats[key] || 0
    }
    return val;
};

const processDirection =val=> {
    let v = 0;
    if(!isNaN(parseInt(val))) {
        v = parseInt(val);
    }
    return v % 360;
};

const isVisible =(val, data, vehicle)=> {
    if(vehicle && ((vehicle.vehicleModel && vehicle.vehicleModel.vehicletype && vehicle.vehicleModel.vehicletype.toLowerCase() === 'bike')) ||
        vehicle.vehiclemeta && vehicle.vehiclemeta.vehicletype && vehicle.vehiclemeta.vehicletype.toLowerCase() === 'bike') {
        return 'hide';
    }
    return val != null ? val : 'NA';
};

const processLastTalkedTime =(val, data, vehicle)=> {
    let cantime = parseInt(vehicle.stats.canproctime, 10);
    cantime = isNaN(cantime) ? 0 : cantime;
    let gpstime = parseInt(vehicle.stats.gpsproctime, 10);
    gpstime = isNaN(gpstime) ? 0 : gpstime;
    if(window.selectedVehicle){
        if(window.selectedVehicle.GPS && window.selectedVehicle.GPS.gpts > gpstime)
            gpstime = window.selectedVehicle.GPS.gpts
        if(window.selectedVehicle.CAN && window.selectedVehicle.CAN.cpts > cantime)
            gpstime = window.selectedVehicle.CAN.cpts
    }

    if(gpstime > cantime) {
        vehicle.stats.lasttalkedtimeSource = 'GPS';
        return gpstime
    }
    vehicle.stats.lasttalkedtimeSource = 'CAN';
    return cantime;
};


export default {
    GPS: [
        {from:'uts', key:'utctime', processData: (val, data, vehicle) => {
                val = parseInt(val, 10);
                vehicle.stats.utctimeGPS = val;
                if(!vehicle.stats.utctime || val > vehicle.stats.utctime) {
                    return val
                }
                return vehicle.stats.utctime;
            }},
        {from:'cts', key: 'cantime', processData: (val, data, vehicle) => {
                val = parseInt(val, 10);
                return isNaN(val) ? 'NA' : val != null ? val : vehicle.stats.cantime;
            }},
        {from:'gpts', key: 'gpsproctime'},
        {from:'cpts', key: 'canproctime'},
        {from:'cpts', key: 'lasttalkedtime', processData: processLastTalkedTime},
        {from:'cb', key: 'carbattery'},
        {from:'db', key: 'devicebattery'},
        {from:'dr', key: 'direction', processData: processDirection},
        {from:'gts',key: 'gpstime'},
        {from:'kts',key: 'kletime'},
        {from:'kts',key: 'klenc', processData: processKLENoComm},
        {from:'ig', key: 'ignitionstatus', processData: [d => { return d ? d : 0}, isValid]},
        {from:'im', key: 'mobilistatus', processData: im=> im ? im : 0},
        {from:'mil',key: 'mil', processData:[ d => {return d ? d : 0}, isVisible]},
        {from:'od', key: 'odometer', processData: (val,data, vehicle)=> {return processOdometer(val, data, vehicle, "GPS")}},
        {from:'cod', key: 'odometer', processData: (val,data, vehicle)=> {return processOdometer(val, data, vehicle, "CAN")}},
        {from:'sod', key: 'odometer', processData: (val,data, vehicle)=> {return processOdometer(val, data, vehicle, "GPSSPEED")}},
        {from:'sp', key: 'speed', processData:isGPSSpeedValid},
        {from:'ta', key: 'tampered'},
        {from:'ui', key: 'user', processData: d => {return d != null ? 1 : 0}},
        {from:'nc', key: 'nocomm', processData: processNoComm},
        {from:'millist', key:'millist'},
        {from:'add', key:'address'},
        {from:'fl', key:'fuel', processData: [NACheck, (val, data, v) =>  {let fuel = Math.min(100, val); return !isNaN(fuel) ? fuel : v.stats.fuel ? v.stats.fuel : 0}]},
        {from:'fl', key:'fuelInLiters', processData: [NACheck, getFuelInLiters], condition:isFuelInLitersAvailable},
        {from:'fl2', key:'fuel2', updateOnlyIfvalid: true,  processData: [NACheck, (val, data, v) =>  {let fuel2 = Math.min(100, val); return !isNaN(fuel2) ? fuel2 : v.stats.fuel2 ? v.stats.fuel2 : 0}]},
        {from:'fl2', key:'fuel2InLiters', updateOnlyIfvalid: true, processData: [NACheck, getFuel2InLiters], condition:isFuel2InLitersAvailable},
       {from:'bv', key:'batteryVoltage', processData: [NACheck, getBatteryVoltage]},
        {from:'dte', key:'dte', processData: [NACheck]},
        // KLE
        {from:'pn', key:'panicButton', processData: [NACheck]},
        {from:'pnt', key:'panicButtonTime', processData: [NACheck]},
        {from:'dops', key:'dooropenstate', processData: [NACheck, isVisible], default:'NA'},
        {from:'rm', key:'ridemode', processData: [isValid], default: null},
        {from:'fq', key: 'fixquality'},
        {from:'maxct', key:'cellTemp'},
        {from: 'dst', key: 'device_state'},


    ],

    USERGPS: [
        {from:'uts', key:'utctime', processData: (val, data, vehicle) => {
                val = parseInt(val, 10);
                vehicle.stats.utctimeGPS = val;
                if(!vehicle.stats.utctime || val > vehicle.stats.utctime) {
                    return val
                }
                return vehicle.stats.utctime;
        }},
        {from:'ui', key: 'user', processData: d => {return d != null ? 1 : 0}},
        {from:'sp', key: 'speed', processData:isGPSSpeedValid},
        {from:'dr', key: 'direction', processData: processDirection},
        {from:'cs', key: 'chargingStatus'},
        {from:'add', key:'address'},
    ],
    

    // 'carbattery','devicebattery', 'direction', 'gpstime', 'kletime', 'ignitionstatus',, 'mobilistatus', 'mil', 'nocomm', 'odometer', 'speed', 'tampered','gpstime'

    PHONEINFO: [
        {from:'uts',key: 'time', processData: (val, data, user)=> {
            let time = parseInt(val);
            user.stats.signalStatus = user.stats.locationStatus = Date.now() - time < 60 * 60 * 2 && user.stats ? 1 : 0;
            return time
        }},
        {from:'rf', key: 'ramFree'},
        {from:'ru', key: 'ramUsed'},
        {from:'br', key: 'batteryRemaining'},
        {from:'cu', key: 'cpuUsage', processData:d=>{return parseFloat((d * 100).toFixed(2))}},
        {from:'bc', key: 'batteryCapacity'},
        {from:'ss', key: 'ssid'},
        {from:'cs', key: 'chargingStatus'},
        {from:'ws', key: 'wifiStatus'},
        {from:'bs', key: 'bluetoothStatus'},
        {from:'tm', key: 'temperature'},

        {from:'mo', key: 'model'},
        {from:'ma', key: 'manufacturer'},
        {from:'av', key: 'androidVersion'},
    ],


    CAN2: [
        {from:'uts',key: 'utctime'},
        {from:'sp', key: 'speed'},
        {from:'es', key: 'eStop'},
        {from:'mm', key: 'machineMovement'},
        {from:'aci',key: 'airFilterClogIndicator'},
        {from:'eop',key: 'engineOilPressure'},
        {from:'ect',key: 'engineCoolentTemp'},
        {from:'fl', key: 'fuelLevel', updateOnlyIfvalid: true},
        {from:'cs', key: 'chargingStatus'},
        {from:'bv', key: 'batteryVoltage'},
        {from:'hm', key: 'hourMeter'},
        {from:'vs', key: 'vibrationStatus'},
        {from:'en', key: 'engineStatus'},
        {from:'ig', key: 'ignition'},
    ],

    TPMS: [
        {from:'tpmsinfo', key:'tmps', processData: processTPMS},
    ],

    DTC: [
        {from:'millist', key:'millist'},
    ],

    CAN: [
        {from:'uts', key:'utctime',
            processData: (val, data, vehicle) => {
                val = parseInt(val, 10);
                if(!vehicle.stats.utctime || val > vehicle.stats.utctime) {
                    return val
                }
                return vehicle.stats.utctime;
            }},
        {from: 'cts', key: 'cantime'},
        {from:'ac', key:'ac', processData: [NACheck, isValid, isVisible], default: 'NA'},
        {from:'ap', key:'accPedal', processData: [NACheck, isValid]},
        {from:'cpts', key: 'canproctime'},
        {from:'cpts', key: 'lasttalkedtime', processData: processLastTalkedTime},
        {from:'bp', key:'breakPedal', processData: [NACheck, isValid]},
        // {from:'cb', key:'carbattery', processData: [NACheck, isValid]},
        {from:'cp', key:'clutchPedal', processData: [NACheck, isValid]},
        // {from:'db', key:'devicebattery', processData: [NACheck, isValid]},
        {from:'et', key:'enginetemp', processData: [NACheck, isValid, isVisible]},
        {from:'fl', key:'fuel', updateOnlyIfvalid: true, processData: [NACheck, (val, data, v) =>  {let fuel = Math.min(100, val); return !isNaN(fuel) ? fuel : v.stats.fuel ? v.stats.fuel : 0}]},
        {from:'fl', key:'fuelInLiters', updateOnlyIfvalid: true, processData: [NACheck, getFuelInLiters], condition:isFuelInLitersAvailable},
        {from:'fl2', key:'fuel2', updateOnlyIfvalid: true,  processData: [NACheck, (val, data, v) =>  {let fuel2 = Math.min(100, val); return !isNaN(fuel2) ? fuel2 : v.stats.fuel2 ? v.stats.fuel2 : 0}]},
        {from:'fl2', key:'fuel2InLiters', updateOnlyIfvalid: true, processData: [NACheck, getFuel2InLiters], condition:isFuel2InLitersAvailable},
        {from:'gp', key:'gearposition', processData:[NACheck, processGear, isValid], default: 'NA'},//
        {from:'hl', key:'headlight', processData: [NACheck, isValid, isVisible], default: 'NA'},
        {from:'odc', key:'odometerc', processData: [NACheck]},
        {from:'od', key:'odometer', processData: [NACheck, (val,data, vehicle)=> {return processOdometer(val,data, vehicle, "CAN")}]},
        {from:'pb', key:'parkingbreak', processData: [NACheck, isValid, isVisible], default: 'NA'},
        {from:'rp', key:'rpm', processData:[NACheck, (d, msg, v)=> { let rpm = parseInt(d, 10); return !isNaN(rpm) ? rpm : v.stats.rpm ? v.stats.rpm : 0}, isValid]},
        {from:'sb', key:'seatbelt', processData: [isValid, isVisible], default: 'NA'},
        {from:'sp', key:'speed', processData: [NACheck, (val, data, vehicle) =>  {return !val || val == 'NA' ? vehicle.stats.speed : parseInt(val, 10)}, isValid]},
        {from:'ind', key:'indicator', processData: [NACheck, isVisible]},
        {from:'flts', key:'fuelTime'},
        {from:'flts2', key:'fuelTime2'},
        //oyerickshaw
        {from:'bv', key: 'batteryVoltage', processData: [NACheck]},
        // EV
        {from:'dte', key:'dte', processData: [(val, d, v) => {if(val) return val} ]},

        // Paver
        {from:'lst', key:'left_screed_temperature', condition:isPaverData, processData: [isValid]},
        {from:'rst', key:'right_screed_temperature', condition:isPaverData, processData: [isValid]},
        {from:'bct', key:'base_screed_temperature', condition:isPaverData, processData: [isValid]},
        {from:'aes', key:'actualenginespeed', condition:isPaverData, processData: [isValid]},
        {from:'eh', key:'enginehours', condition:isPaverData, processData: [isValid]},
        {from:'ds', key:'drivespeed', condition:isPaverData, processData: [isValid]},
        {from:'bci', key:'batterychargeindication', condition:isPaverData, processData: [isValid]},
        {from:'wh', key:'worktimehours', condition:isPaverData, processData: [isValid]},
        {from:'wm', key:'worktimeminutes', condition:isPaverData, processData: [isValid]},
        {from:'pd', key:'pavingdistance', condition:isPaverData, processData: [isValid]},
        {from:'wlm', key:'worktimerlowgearmoving', condition:isPaverData, processData: [isValid]},
        {from:'wli', key:'worktimerlowgearidle', condition:isPaverData, processData: [isValid]},
        {from:'tdl', key:'traveldistancelowgear', condition:isPaverData, processData: [isValid]},
        {from:'tdh', key:'traveldistancehighgear', condition:isPaverData, processData: [isValid]},
        {from:'iig', key:'io_ignitionkeyfeed', condition:isPaverData, processData: [isValid]},
        {from:'iov', key:'iov1ecupwrref5val', condition:isPaverData, processData: [isValid]},
        {from:'ioe', key:'io_emergencystop', condition:isPaverData, processData: [isValid]},
        {from:'whm', key:'worktimerhighgearmoving', condition:isPaverData, processData: [isValid]},
        {from:'whi', key:'worktimerhighgearidle', condition:isPaverData, processData: [isValid]},
        {from:'eol', key:'engineoillowpressure', condition:isPaverData, processData: [isValid]},
        {from:'hct', key:'highcoolanttemp', condition:isPaverData, processData: [isValid]},
        {from:'sm', key:'serialnumbermsb', condition:isPaverData, processData: [isValid]},
        {from:'sl', key:'serialnumberlsb', condition:isPaverData, processData: [isValid]},
        {from:'mm', key:'modelnumbermsb', condition:isPaverData, processData: [isValid]},
        {from:'ml', key:'modelnumberlsb', condition:isPaverData, processData: [isValid]},
        {from:'hfi', key:'hydraulicoilfilterindicator', condition:isPaverData, processData: [isValid]},
        {from:'ioa', key:'io_airfilterstatus', condition:isPaverData, processData: [isValid]},
        {from:'shm', key:'screedheatingmode', condition:isPaverData, processData: [isValid]},
        {from:'shsr', key:'screedheatingsensorstatusr', condition:isPaverData, processData: [isValid]},
        {from:'shsl', key:'screedheatingsensorstatusl', condition:isPaverData, processData: [isValid]},
        {from:'shsb', key:'screedheatingsensorstatusb', condition:isPaverData, processData: [isValid]},

        // TVS Scooter
        {from:'tvs_fuel', key:'tvsFuel', processData: [isValid]},
        {from:'tvs_oiltemp', key:'oiltemp', processData: [isValid]},
        {from:'tvs_rpm', key:'tvsRpm', processData: [isValid]},
        {from:'tvs_speed', key:'tvsSpeed', processData: [isValid]},
        {from:'tvs_diff', key:'diff', processData: [isValid]},
        {from:'tvs_finn', key:'finn', processData: [isValid]},
        {from:'tvs_accx', key:'accX', processData: [isValid]},
        {from:'tvs_accy', key:'accY', processData: [isValid]},
        {from:'tvs_accz', key:'accZ', processData: [isValid]},
        {from:'tvs_helmet', key:'helmet', processData: [isValid]},
        {from:'tvs_frontodo', key:'frontodo', processData: [isValid]},
        {from:'tvs_map', key:'map', processData: [isValid]},
        {from:'tvs_rearodo', key:'rearodo', processData: [isValid]},
        {from:'tvs_rspeed', key:'rspeed', processData: [isValid]},
        {from:'tvs_battery_amp', key:'tvsBatteryA', processData: [isValid]},
        {from:'tvs_battery_volt', key:'batteryV', processData: [isValid]},
        {from:'tvs_indicator_left', key:'indicatorLeft', processData: [isValid]},
        {from:'tvs_indicator_right', key:'indicatorRight', processData: [isValid]},
        {from:'tvs_horn', key:'tvsHorn', processData: [isValid]},
        {from:'tvs_throttle', key:'tvsThrottle', processData: [isValid]},
        {from:'tvs_brakef', key:'tvsBrakeF', processData: [isValid]},
        {from:'tvs_braker', key:'tvsBrakeR', processData: [isValid]},

        // TORK
        {from:'mtrtemp', key:'motortemp', processData: [isValid]},
        {from:'ecutemp', key:'ecutemp', processData: [isValid]},
        {from:'torq', key:'torque', processData: [isValid]},
        {from:'thrtvolt', key:'throttleV', processData: [isValid]},
        {from:'curr', key:'batteryA', processData: [isValid]},
        {from:'volt', key:'vol', processData: [isValid]},
        {from:'rb', key:'brakeR', processData: [isValid]},
        {from:'fb', key:'brakeF', processData: [isValid]},
        {from:'ho', key:'horn', processData: [isValid]},
        // {from:'', key:'batteryPercent', processData: [isValid]},
        // {from:'', key:'indicatorL', processData: [isValid]},
        // {from:'', key:'indicatorR', processData: [isValid]},
        {from:'th', key:'throttle', processData: [isValid]},
        {from:'lbhb', key:'highBeam', processData: [isValid]},
        {from:'ps', key:'pass', processData: [isValid]},
        {from:'drl', key:'drl', processData: [isValid]},
        {from:'tl', key:'tailLamp', processData: [isValid]},
        {from:'ks', key:'killSwitch', processData: [isValid]},
        {from:'ch', key:'torkChargingStatus', processData: [isValid]},
        
        // etrio
        {from:'soh', key:'soh', processData: []}, // state of health
        {from:'btv', key:'btv', processData: []}, // battery voltage, EV
        {from:'cr', key:'batcurrent', processData: []}, // current
        {from:'ct', key:'maxcelltemp', processData: []}, // cell temperature
        {from:'minct', key:'mincelltemp', processData: []}, // cell temperature
        {from:'mtrtmp', key:'motortemp', processData: []}, // motor temperature
        {from:'ctrtmp', key:'ctrltemp', processData: []}, // controller temperature
        {from:'mincellv', key:'mincellvolt', processData: []}, // cell voltage
        {from:'maxcellv', key:'maxcellvolt', processData: []}, // cell voltage
        // amplus
        //  Not masking values because we're already using the original keys
        //  makes it easier. keys:
        //  bmstmp
        // tiv throttle input voltage
        {from:'chc', key:'chc'},
        // greenfuel
        {from:'battmp', key:'batteryTemp'},
        {from:'kwh', key:'kwh'},
        {from: 'bmstmp', key:'bmstmp'},
        {from: 'chtype', key:'chargeType'},
        {from: 'allowchg', key: 'allowchg'},
        {from: 'allowdischg', key: 'allowdischg'},
        {from:'maxct', key:'cellTemp'},
    ]

}